import classNames from "classnames/bind";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Alert, Loading, Toast } from "../../../../components";
import { BackIcon } from "../../../../components/Icons/Icons";
import axiosClient from "../../../../services/axiosClient";
import styles from './InfoDetail.module.css';
import SideBarInfo from "./SideBarInfo";
import imageEmty from '../../../../assets/images/Emty.png'
import { formatDB } from "../../../../utils";
const cx = classNames.bind(styles);

function InfoDetail() {
    const [isAlert, setIsAlert] = useState(false)
    const [infoUser, setInfoUser] = useState([])
    const [name, setName] = useState('')
    const [newData, setNewData] = useState()
    const [message, setMessage] = useState()
    const [changed, setChanged] = useState(false)
    const [code, setCode] = useState()
    const [loading, setLoading] = useState(true)
    const navigate = useNavigate()
    useEffect(() => {
        const code = sessionStorage.getItem('code')
        setCode(code)
        if (!!code) {
            const getData = async () => {
                try {
                    const info = await axiosClient.get(`userManagement/get-user-info/?user_code=${code}`)
                    setInfoUser(info)
                    const name = info.map(item => {
                        return item.NAME
                    })
                    setLoading(false)
                    setName(name[0])
                } catch (error) {
                    throw new Error('Opps!')
                }
            }
            getData()
        }
    }, [])

    const getData = (data) => {
        setNewData(data)
    }

    const handleBack = () => {
        sessionStorage.removeItem('code')
    }

    const handleOk = () => {
        navigate('/admin/user')
        sessionStorage.removeItem('code')
        setCode()
    }

    const handleSubmit = () => {
        if (!changed) {
            setIsAlert(true)
            setMessage('Bạn chưa thay đổi gì')
        } else {
            setLoading(true)
            const changeInfo = async () => {
                try {
                    const res = await axiosClient.put(`/userManagement/put-change-user-info/?user_code=${code}`, {
                        name: newData.name,
                        staff_position_code: newData.staffCode,
                        usertype_code: newData.codeType,
                        birthday: formatDB(newData.birthDay),
                        nation_code: newData.nationCode,
                        phone: newData.phone,
                        address_detail: newData.address,
                        email: newData.email
                    })
                    setLoading(false)
                    Toast.open('Thay đổi thành công', 'success')
                    navigate('/admin/user')
                    return res
                } catch (error) {
                    setLoading(false)
                    if (error.response.status) {
                        Toast.open('Bạn không thể thay đổi thông tin của chính mình', 'danger')
                    } else {
                        Toast.open('Thay đổi không thành công', 'danger')
                    }
                }
            }
            changeInfo()
        }
    }

    const handleCancel = () => {
        setIsAlert(true)
    }
    return (
        <>{
            loading ? <div className={cx('modal-loading')}><Loading /></div> : <>
                <div id="__notification"></div>
                {isAlert && <Alert type="alert" title={message} onClose={(e) => (setIsAlert(false))} onOk={handleOk} />}
                <div className={cx('info-detail')}>
                    <div className={cx('header')}>
                        <Link className={cx('button-back')} onClick={handleBack} to={'/admin/user'}>
                            <BackIcon />
                            <h1 className={cx('user-name')}>
                                {name}
                            </h1>
                        </Link>
                    </div>
                    <div className={cx('detail-container')}>
                        {infoUser?.length === 0 ?
                            <div className={cx('emty')}>
                                <div className={cx('emty-container')}>
                                    <img src={imageEmty} alt={'emty'} className={cx('img-emty')} />
                                    <p>Người dùng này hiện không hoạt động</p>
                                </div>
                            </div>
                            :
                            <SideBarInfo data={infoUser} getData={getData} changed={setChanged} />}
                    </div>
                    <div className={cx('button-control')}>
                        <div className={cx('cancel-button')} onClick={handleCancel}>
                            Huỷ bỏ
                        </div>
                        <div className={cx('submit-button')} onClick={handleSubmit}>
                            Xác nhận
                        </div>
                    </div>
                </div>
            </>
        }</>
    )
}

export default InfoDetail;